Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _reactNative = require("react-native-web");
var _styles = require("../../styles");
var useStyles = exports.useStyles = function useStyles() {
  var _STYLES$useStyles = _styles.STYLES.useStyles(),
    colors = _STYLES$useStyles.colors,
    COLORS = _STYLES$useStyles.COLORS,
    focused = _STYLES$useStyles.focused,
    spacing = _STYLES$useStyles.spacing,
    disabled = _STYLES$useStyles.disabled,
    fontBold = _STYLES$useStyles.fontBold,
    fontRegular = _STYLES$useStyles.fontRegular;
  var styles = _reactNative.StyleSheet.create({
    container: Object.assign({
      flexDirection: 'row',
      alignItems: 'flex-start'
    }, _reactNative.Platform.select({
      web: {
        cursor: 'pointer'
      }
    })),
    checkbox: {
      position: 'absolute',
      left: (0, _styles.getREM)(-999)
    },
    fakeCheckbox: {
      width: (0, _styles.getREM)(1.125),
      height: (0, _styles.getREM)(1.125),
      borderWidth: (0, _styles.getREM)(0.0625),
      borderStyle: 'solid',
      borderColor: colors.brand,
      borderRadius: (0, _styles.getREM)(0.125),
      backgroundColor: COLORS.white,
      justifyContent: 'center',
      alignItems: 'center',
      marginTop: (0, _styles.getREM)(0.375)
    },
    fakeCheckbox_checked: {
      backgroundColor: colors.brand
    },
    fakeCheckbox_focused: Object.assign({}, focused),
    tick: {
      width: (0, _styles.getREM)(0.625),
      height: (0, _styles.getREM)(0.625)
    },
    indexContainer: {
      width: (0, _styles.getREM)(1.875),
      height: (0, _styles.getREM)(1.875),
      borderRadius: (0, _styles.getREM)(0.9375),
      backgroundColor: COLORS.white,
      borderWidth: (0, _styles.getREM)(0.0625),
      borderStyle: 'solid',
      borderColor: COLORS.silver,
      marginLeft: spacing.xs,
      flexShrink: 0,
      justifyContent: 'center',
      alignItems: 'center'
    },
    indexContainer_checked: {
      backgroundColor: COLORS.cherry,
      borderColor: COLORS.cherry
    },
    index: Object.assign({}, fontBold, {
      color: colors.brand,
      textAlign: 'center',
      fontSize: _styles.STYLES.fontSize.s,
      lineHeight: (0, _styles.getREM)(1.75)
    }),
    index_checked: {
      color: COLORS.white
    },
    indexTextContainer: {
      textAlign: 'center',
      marginBottom: 0
    },
    label: Object.assign({}, fontRegular, {
      fontSize: _styles.STYLES.fontSize.s,
      lineHeight: _styles.STYLES.lineHeight.s,
      color: colors.text,
      flexShrink: 1
    }),
    labelContainer: {
      marginTop: (0, _styles.getREM)(0.25),
      marginLeft: spacing.xs,
      marginBottom: 0
    },
    disabled: disabled
  });
  return {
    styles: styles
  };
};